import { ogImageMeta } from "@/lib/og-images";
import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, LegalSection } from "@/components/legal-layout";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — the Vibing Company®" },
      { name: "description", content: "Which cookies the Vibing Company® uses, why, and how to control them." },
      { property: "og:title", content: "Cookie Policy — the Vibing Company®" },
      ...ogImageMeta("cookies", "Share card: cookie policy"),
      { property: "og:description", content: "Which cookies the Vibing Company® uses, why, and how to control them." },
    ],
    links: [{ rel: "canonical", href: "/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <LegalLayout kicker="03.COOKIES" title="Cookie Policy" updated="June 2026">
      <LegalSection label="01" title="What are cookies">
        <p>
          Cookies are small text files stored on your device when you visit a website. We also
          use comparable browser storage (localStorage) for the same purposes described below.
        </p>
      </LegalSection>

      <LegalSection label="02" title="Strictly necessary">
        <p>
          These are required for the site to function and cannot be switched off. They store
          your intake thread id, session, and basic security flags. Legal basis: Art. 6(1)(f)
          GDPR and § 25 (2) TTDSG.
        </p>
      </LegalSection>

      <LegalSection label="03" title="Functional">
        <p>
          With your consent we may set cookies that remember preferences such as theme or
          language. Legal basis: Art. 6(1)(a) GDPR.
        </p>
      </LegalSection>

      <LegalSection label="04" title="Analytics">
        <p>
          If you consent, we use privacy-respecting analytics to understand which pages are
          useful. No cross-site tracking, no advertising profiles.
        </p>
      </LegalSection>

      <LegalSection label="05" title="Third-party services">
        <p>
          Payments are processed by Stripe, which sets its own cookies when you reach the
          checkout. Their cookie information is available on stripe.com.
        </p>
      </LegalSection>

      <LegalSection label="06" title="Controlling cookies">
        <p>
          You can clear or block cookies in your browser at any time. Blocking strictly
          necessary cookies may break parts of the site (e.g. the intake assistant).
        </p>
      </LegalSection>

      <LegalSection label="07" title="Contact">
        <p>
          Questions:{" "}
          <a href="mailto:jon@vibing.inc" className="underline">jon@vibing.inc</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
